import { CASE_STUDIES } from "@/data/site";
import { Eyebrow, FadeIn } from "@/components/blocks";

export default function Proof() {
  return (
    <section data-testid="proof-section" className="bg-bone px-6 py-28 text-ink sm:px-10 sm:py-36 lg:px-16">
      <div className="mx-auto max-w-[1440px]">
        <FadeIn>
          <Eyebrow tone="ink">Proof / In Documentation</Eyebrow>
        </FadeIn>
        <FadeIn delay={0.1}>
          <h2 className="mt-8 max-w-3xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-6xl">
            Results we can <span className="text-ink/40">stand behind.</span>
          </h2>
        </FadeIn>
        <FadeIn delay={0.15}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-smoke">
            We publish outcomes, not slogans. Verified StrengthLeap case studies are documented with client consent
            and released as they complete.
          </p>
        </FadeIn>

        <div className="mt-16">
          {/* Replace with verified StrengthLeap case studies before launch. */}
          {CASE_STUDIES.map((c, i) => (
            <FadeIn key={c.n} delay={i * 0.08}>
              <article
                data-testid={`case-study-${c.n}`}
                className="group grid gap-4 border-t border-ink/15 py-10 last:border-b sm:grid-cols-[120px_1fr_auto] sm:items-center sm:gap-10"
              >
                <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink/50">Case Study {c.n}</p>
                <div>
                  <h3 className="font-display text-2xl font-black uppercase tracking-tight sm:text-3xl">{c.title}</h3>
                  <p className="mt-2 text-sm text-smoke">{c.status}</p>
                </div>
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-ember">
                  {c.track}
                </p>
              </article>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
